/* @flow */

/**
 * @module bidmanager-stub
 * @description No-op bid manager when ENABLE_HB is false at compile time
 */

class _bidManagerStub {
  init(g: globalParam) {}

  updateConfig(oConfig?: hbBiddersData) {}

  getBidPos(pName: string = ''): Array<string> {
    return [];
  }

  getDecodedBidFromBidder(hb_bidder: string = '', hb_pb: string = ''): number {
    return 0;
  }

  getBids(
    posList: Array<string> = [],
    pName: string = '',
    adRotation: boolean = false
  ): Promise<hbPartnerData> {
    return Promise.resolve({});
  }

  renderAd(
    win: WindowProxy,
    doc: Document,
    pos: string,
    partner: string,
    param: string,
    posInfo: posConfigInfo
  ) {}
}

const bm: _bidManagerStub = new _bidManagerStub();
export default bm;
